import React from 'react';
import TrafficMap from './TrafficMap';

export default function Hero() {
  return (
    <section className="hero" id="top" style={{ borderTop: 'none', padding: '168px 0 100px' }}>
      <div className="container hero-grid">
        <div>
          <div className="eyebrow">Infraestrutura para empresas de rastreamento</div>
          <h1>Construa <span className="hl">seu próprio negócio</span> de rastreamento.</h1>
          <p className="lead">A Nivocar entrega a plataforma, os aplicativos. Você entra com a marca e a carteira de clientes — e sai vendendo.</p>
          <div className="hero-ctas">
            <a href="#form" className="btn btn-primary">Quero ser parceiro</a>
            <a href="#plataforma" className="btn btn-ghost">Conhecer a plataforma</a>
          </div>
          <p className="hero-coop">
            <h2>É uma cooperativa ou associação e quer <strong>terceirizar</strong> o rastreamento da sua frota? <a href="#form">Fala com a gente →</a></h2>
          </p>
          <div className="hero-stats">
            <div><div className="stat-num">24/7</div><div className="stat-label">Monitoramento contínuo</div></div>
            <div><div className="stat-num">&lt;15s</div><div className="stat-label">Atualização de posição</div></div>
            <div><div className="stat-num">100%</div><div className="stat-label">Marca própria do parceiro</div></div>
          </div>
        </div>

        <TrafficMap />
      </div>
    </section>
  );
}
